import { render } from "./ProductToPriceGroups.vue?vue&type=template&id=87095a78&ts=true"
import script from "./ProductToPriceGroups.vue?vue&type=script&lang=ts"
export * from "./ProductToPriceGroups.vue?vue&type=script&lang=ts"

import "./ProductToPriceGroups.vue?vue&type=style&index=0&id=87095a78&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__